// component
import List from './index.vue';
import details from './details2/index.vue';
import finance from './finance/index.vue';
import InformationDetails from './Information-details/index.vue';
import InformationList from './Information-list/index.vue';

export default [
  {
    path: 'list',
    name: '',
    component: List,
    meta: {
      title: '产品列表',
      keepAlive: true
      // breadCrumbShowIndexArr: [0]
    }
  },
  {
    path: 'details',
    name: '',
    component: details,
    meta: {
      title: '详情',
      keepAlive: true,
      breadCrumbShowIndexArr: [0, 1]
    }
  },
  {
    path: 'finance',
    name: '',
    component: finance,
    meta: {
      title: '金融产品列表',
      keepAlive: true,
      breadCrumbShowIndexArr: [0, 1]
    }
  },
  {
    path: 'InformationDetails',
    name: '',
    component: InformationDetails,
    meta: {
      title: '信息详情',
      keepAlive: true,
      breadCrumbShowIndexArr: [0, 1]
    }
  },
  {
    path: 'InformationList',
    name: '',
    component: InformationList,
    meta: {
      title: '信息列表',
      keepAlive: true,
      breadCrumbShowIndexArr: [0, 1]
    }
  }
];
